'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgChevrondown, SvgChevronup } from '@common/icon';
import { cn } from '@core/utils';
import { useCallback, useEffect, useRef, useState } from 'react';
import { TABS } from '../constants';
import { TabDelivery } from './TabDelivery';
import { TabInquiry } from './TabInquiry';
import { TabProductInfo } from './TabProductInfo';
import { TabReview } from './TabReview';
const COLLAPSED_HEIGHT = 500;
interface MarketDetailContentProps {
  productInfo: string;
  productInfoSections: Array<{
    sectionName: string;
    items: Array<{
      key: string;
      value: string;
    }>;
  }>;
  vendorContactNumber: string;
  deliveryFee: number;
  deliveryCompanyName: string;
  productId: string;
  productImageUrl?: string;
  vendorRegion?: string;
  vendorName?: string;
  productName?: string;
}
export const MarketDetailContent = t0 => {
  const $ = _c(39);
  const {
    productInfo,
    productInfoSections,
    vendorContactNumber,
    deliveryFee,
    deliveryCompanyName,
    productId,
    productImageUrl,
    vendorRegion,
    vendorName,
    productName
  } = t0;
  const [isExpanded, setIsExpanded] = useState(false);
  const sectionRef = useRef(null);
  const contentRef = useRef(null);
  const isAnimating = useRef(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const element = contentRef.current;
      if (!element) {
        return;
      }
      element.style.maxHeight = `${COLLAPSED_HEIGHT}px`;
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const element_0 = contentRef.current;
      if (!element_0 || isAnimating.current) {
        return;
      }
      isAnimating.current = true;
      element_0.style.transition = "max-height 300ms ease-in-out";
      element_0.style.maxHeight = `${element_0.scrollHeight}px`;
      const onEnd = () => {
        element_0.style.maxHeight = "none";
        element_0.style.transition = "";
        isAnimating.current = false;
        element_0.removeEventListener("transitionend", onEnd);
      };
      element_0.addEventListener("transitionend", onEnd);
      setIsExpanded(true);
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleExpand = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const element_1 = contentRef.current;
      if (!element_1 || isAnimating.current) {
        return;
      }
      isAnimating.current = true;
      const sectionTop = sectionRef.current?.getBoundingClientRect().top ?? 0;
      const scrollY = window.scrollY;
      element_1.style.transition = "none";
      element_1.style.maxHeight = `${element_1.scrollHeight}px`;
      requestAnimationFrame(() => {
        element_1.style.transition = "max-height 300ms ease-in-out";
        element_1.style.maxHeight = `${COLLAPSED_HEIGHT}px`;
      });
      const onEnd_0 = () => {
        element_1.style.transition = "";
        isAnimating.current = false;
        element_1.removeEventListener("transitionend", onEnd_0);
        const newSectionTop = sectionRef.current?.getBoundingClientRect().top ?? 0;
        const diff = newSectionTop - sectionTop;
        window.scrollTo({
          top: scrollY + diff
        });
      };
      element_1.addEventListener("transitionend", onEnd_0);
      setIsExpanded(false);
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleCollapse = t4;
  let t5;
  if ($[4] !== productInfo) {
    t5 = <div ref={contentRef} className="prose max-w-none overflow-hidden" dangerouslySetInnerHTML={{
      __html: productInfo
    }} />;
    $[4] = productInfo;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = isExpanded ? "opacity-0" : "opacity-100";
  let t7;
  if ($[6] !== t6) {
    t7 = cn("pointer-events-none absolute inset-x-0 bottom-0 h-100 bg-gradient-to-t from-Gray-white to-transparent transition-opacity duration-300", t6);
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t7) {
    t8 = <div className={t7} />;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t5 || $[11] !== t8) {
    t9 = <div className="relative">{t5}{t8}</div>;
    $[10] = t5;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== isExpanded) {
    t10 = !isExpanded ? <button type="button" onClick={handleExpand} className="mt-16 flex w-full items-center justify-center gap-4 border border-Gray-300 py-12 font-600 text-Gray-700 typo-body3">상품정보 더보기<SvgChevrondown className="size-16 text-Gray-600" /></button> : <button type="button" onClick={handleCollapse} className="mt-16 flex w-full items-center justify-center gap-4 border border-Gray-300 py-12 font-600 text-Gray-700 typo-body3">상품정보 접기<SvgChevronup className="size-16 text-Gray-600" /></button>;
    $[13] = isExpanded;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t9) {
    t11 = <section id={TABS.BASIC} ref={sectionRef} className="mobile-tablet:px-20">{t9}{t10}</section>;
    $[15] = t10;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const t12 = vendorName ?? "";
  let t13;
  if ($[18] !== productInfoSections || $[19] !== t12 || $[20] !== vendorContactNumber) {
    t13 = <TabProductInfo productInfoSections={productInfoSections} vendorName={t12} vendorContactNumber={vendorContactNumber} />;
    $[18] = productInfoSections;
    $[19] = t12;
    $[20] = vendorContactNumber;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== deliveryCompanyName || $[23] !== deliveryFee) {
    t14 = <TabDelivery deliveryFee={deliveryFee} deliveryCompanyName={deliveryCompanyName} />;
    $[22] = deliveryCompanyName;
    $[23] = deliveryFee;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== productId) {
    t15 = <TabReview productId={productId} />;
    $[25] = productId;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== productId || $[28] !== productImageUrl || $[29] !== productName || $[30] !== vendorName || $[31] !== vendorRegion) {
    t16 = <TabInquiry productId={productId} productImageUrl={productImageUrl} vendorRegion={vendorRegion} vendorName={vendorName} productName={productName} />;
    $[27] = productId;
    $[28] = productImageUrl;
    $[29] = productName;
    $[30] = vendorName;
    $[31] = vendorRegion;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t11 || $[34] !== t13 || $[35] !== t14 || $[36] !== t15 || $[37] !== t16) {
    t17 = <div className="flex flex-col gap-80 mobile-tablet:gap-40">{t11}{t13}{t14}{t15}{t16}</div>;
    $[33] = t11;
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  return t17;
};